const styles = {
  itemWrapper: {
    width: '100%',
    padding: '5px 0px',
    display: 'flex',
  },
  itemKey: {
    width: 150,
    paddingRight: 15,
    flexShrink: 0,
  },
  btnWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  listItem: {
    display: 'flex',
  },
  counter: {
    width: 30,
    marginTop: 5,
    marginRight: 15,
  },
  description: {
    marginTop: 10,
    fontSize: 16,
  },
};

export default styles;
